<nav class="navbar navbar-fixed-top">
  <div class="container-fluid">
    <div class="navbar-brand">
      <button
        type="button"
        (click)="fullWidthToggle()"
        class="btn-toggle-offcanvas"
      >
        <i class="fa fa-bars"></i>
      </button>
      <button
        type="button"
        (click)="fullWidthToggle()"
        class="btn-toggle-fullwidth"
      >
        <i class="fa fa-bars"></i>
      </button>
      &nbsp;<a [routerLink]="['/dashboard/analytical']">SHRUTSANGAM</a>
    </div>

    <div class="navbar-right">
      <div id="navbar-menu">
        <ul class="nav navbar-nav">
          <!-- <li class="dropdown">
            <a href="javascript:void(0);" class="dropdown-toggle icon-menu" data-toggle="dropdown">
              <i class="fa fa-bell"></i>
              <span class="notification-dot"></span>
            </a>
            <ul class="dropdown-menu notifications">
              <li class="header"><strong>You have 4 new Notifications</strong></li>
              <li>
                <a href="javascript:void(0);">
                  <div class="media">
                    <div class="media-left">
                      <i class="icon-info text-warning"></i>
                    </div>
                    <div class="media-body">
                      <p class="text">Campaign <strong>Holiday Sale</strong> is nearly reach budget limit.</p>
                      <span class="timestamp">10:00 AM Today</span>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <div class="media">
                    <div class="media-left">
                      <i class="icon-like text-success"></i>
                    </div>
                    <div class="media-body">
                      <p class="text">Your New Campaign <strong>Holiday Sale</strong> is approved.</p>
                      <span class="timestamp">11:30 AM Today</span>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <div class="media">
                    <div class="media-left">
                      <i class="icon-pie-chart text-info"></i>
                    </div>
                    <div class="media-body">
                      <p class="text">Website visits from Twitter is 27% higher than last week.</p>
                      <span class="timestamp">04:00 PM Today</span>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <div class="media">
                    <div class="media-left">
                      <i class="icon-info text-danger"></i>
                    </div>
                    <div class="media-body">
                      <p class="text">Error on website analytics configurations</p>
                      <span class="timestamp">Yesterday</span>
                    </div>
                  </div>
                </a>
              </li>
              <li class="footer"><a href="javascript:void(0);" class="more">See all notifications</a></li>
            </ul>
          </li> -->
          <li style="background-color: #a94442; border-radius: 0.25rem">
            <a
              href="javascript:void(0);"
              class="icon-menu"
              title="Update Profile"
              [routerLink]="['/dashboard/update-profile']"
              ><i class="fa fa-cogs" style="color: #fff; font-size: 18px"></i
            ></a>
          </li>
          <li
            class="ml-3"
            style="background-color: #a94442; border-radius: 0.25rem"
          >
            <a
              href="javascript:void(0);"
              class="icon-menu"
              title="Change Password"
              [routerLink]="['/dashboard/change-password']"
              ><i class="fa fa-key" style="color: #fff; font-size: 18px"></i
            ></a>
          </li>
          <li
            class="ml-3"
            style="background-color: #a94442; border-radius: 0.25rem"
          >
            <a
              href="javascript:void(0);"
              (click)="logout()"
              class="icon-menu"
              title="Log Out"
              ><i
                class="fa fa-power-off"
                style="color: #fff; font-size: 18px"
              ></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
